import { render, staticRenderFns } from "./addNews.vue?vue&type=template&id=773c8c70&"
import script from "./addNews.vue?vue&type=script&lang=js&"
export * from "./addNews.vue?vue&type=script&lang=js&"
import style0 from "./addNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports